var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import FDialog from "@ui/components/dialog/FDialog";
import { PrimaryGrid } from "@ui/components/grid/PrimaryGrid";
import { GridCellStack } from "@ui/components/grid";
import { SButton } from "@ui/components/buttons/SButton";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { accessPointsApi, } from "@api/enpoints/access-points-api";
import { useTranslation } from "react-i18next";
export const MaintenanceRequestsDialog = ({ isOpen, onClose, apUid, apName }) => {
    const { t } = useTranslation("common");
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchRequests = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!isOpen || !apUid)
                return;
            setLoading(true);
            setError(null);
            try {
                const response = yield accessPointsApi.getMaintenanceRequests(apUid);
                if (response.data.isSuccess && response.data.data) {
                    setRequests(response.data.data);
                }
                else {
                    setError(response.data.message || "Failed to fetch requests");
                }
            }
            catch (err) {
                setError(((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                    (err === null || err === void 0 ? void 0 : err.message) ||
                    "Failed to fetch maintenance requests");
            }
            finally {
                setLoading(false);
            }
        });
        fetchRequests();
    }, [isOpen, apUid]);
    const columns = [
        {
            field: "createdAt",
            headerName: t("grid.date"),
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                return (React.createElement(GridCellStack, { topText: formatUtcToLocalDate(params.row.createdAt), bottomText: formatUtcToLocalTime(params.row.createdAt, false) }));
            },
        },
        {
            field: "location",
            headerName: t("grid.location"),
            flex: 1,
            minWidth: 120,
        },
        {
            field: "explanation",
            headerName: t("grid.explanation"),
            flex: 2,
            minWidth: 200,
            renderCell: (params) => (React.createElement(Typography, { variant: "body2", sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }, title: params.row.explanation }, params.row.explanation)),
        },
    ];
    const rowsWithId = requests.map((req) => (Object.assign(Object.assign({}, req), { id: req.id })));
    return (React.createElement(FDialog, { isOpen: isOpen, onClose: onClose, onSubmit: onClose, title: `${t("labels.maintenanceRequests")}${apName ? ` - ${apName}` : ""}`, maxWidth: "md", actions: React.createElement(SButton, { variant: "outlined", onClick: onClose }, t("actions.close")) },
        React.createElement(Box, { sx: { minHeight: 300 } }, error ? (React.createElement(Box, { sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
            } },
            React.createElement(Typography, { color: "error" }, error))) : (React.createElement(PrimaryGrid, { rows: rowsWithId, columns: columns, loading: loading, checkboxSelection: false, sx: { height: 400 }, hideFooter: requests.length <= 10 || loading })))));
};
